'use client'

import { cn } from '@/lib/utils'

interface IDesktopBurgerButtonProps {
  onClick: () => void
  isOpen: boolean
}

export function DesktopBurgerButton({
  onClick,
  isOpen
}: IDesktopBurgerButtonProps) {
  return (
    <button
      aria-label="Desktop menu button"
      id="desktop-burger-button"
      onClick={onClick}
      className="flex h-10 w-10 cursor-pointer flex-col items-center justify-center gap-1.5 rounded-full bg-[#F4F4F4] transition-colors hover:bg-gray-200"
    >
      <span
        className={cn(
          'bg-primary-500 h-0.5 w-6 rounded transition-transform duration-300 ease-in-out',
          isOpen ? 'translate-y-1 rotate-45' : ''
        )}
      />
      <span
        className={cn(
          'bg-primary-500 h-0.5 w-6 rounded transition-transform duration-300 ease-in-out',
          isOpen ? '-translate-y-1 -rotate-45' : ''
        )}
      />
    </button>
  )
}
